import type { SalonNote, SalonRow } from '@manaro/contracts'
import { contactSearchText } from './contacts.ts'

export const normalizeSalonSearch = (query: string): string => query.trim().toLocaleLowerCase('ru')

// «1234», «#1234» or «ID 1234», as support copies it from a message or from the CRM.
const SALON_ID_QUERY = /^(?:#|id\s*)?(\d+)$/

/** A salon ID matches exactly; other digits keep matching inside phone numbers. */
const matchesSalonId = (row: SalonRow, query: string): boolean => {
  const id = SALON_ID_QUERY.exec(query)?.[1]
  return id !== undefined && row.salon?.id === Number(id)
}

/** `query` comes from normalizeSalonSearch. */
export function matchesSalonSearch(row: SalonRow, query: string, notes: readonly SalonNote[]): boolean {
  if (!query) return true
  if (matchesSalonId(row, query)) return true

  const contacts = row.salon ? contactSearchText(row.salon) : []
  const noteTexts = notes.map((note) => note.text)
  return [
    row.user.email,
    row.user.name,
    row.user.phone,
    row.salon?.title,
    row.salon?.city,
    row.salon?.phone,
    ...contacts,
    ...noteTexts,
  ]
    .filter(Boolean)
    .some((value) => (value as string).toLocaleLowerCase('ru').includes(query))
}
